export function intersection(array1, array2) {
  let result = [];
  array1.forEach(element => {
    if (array2.indexOf(element) >= 0) {
      result.push(element);
    }
  });
  return result;
}